var _path, _tspan, _tspan2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.32,
    height: 20.8,
    viewBox: "0 0 17.32 20.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "presentation"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2,22.4c-.3,0-.7-.1-1-.1A3.61,3.61,0,0,1,3,19.2V6.2a5.54,5.54,0,0,1,.2-1.8A3.42,3.42,0,0,1,6.3,1.8a14.08,14.08,0,0,1,2-.1h5a1,1,0,1,1,.1,1.9H6.7A1.63,1.63,0,0,0,4.9,5.2V18.3A1.7,1.7,0,0,0,5,19a1.62,1.62,0,0,0,1.6,1.4h8.7a5.7,5.7,0,0,0,1.3-.1A1.7,1.7,0,0,0,18,18.8c0-.4.1-.7.1-1.1V12.1a1.14,1.14,0,0,1,.3-.8.91.91,0,0,1,1.5.3c0,.1.1.1.1.2v6.6c0,.2-.1.5-.1.7a3.61,3.61,0,0,1-3.2,3.1c-.3,0-.7.1-1,.1C12.8,22.4,10,22.4,7.2,22.4Z",
    transform: "translate(-2.95 -1.65)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.07, 0, 0, 1, 8.65, 8.01)",
    fontSize: 3.71,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "pp", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4.6,
    y: 0,
    letterSpacing: "0.01em"
  }, "t")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 6.09,
    y: 0
  }, "x"))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.95 -1.65)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-2.95 -1.65)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.deeb7ba57e2c0716abce07e56f6fcaa2.svg";
export { ForwardRef as ReactComponent };